<script setup lang="ts">
import CustomerManagementList from "@/views/playground/planner/business-management/customer-management/CustomerManagementList.vue";
</script>

<template>
  <customer-management-list></customer-management-list>
</template>

<style scoped></style>
